import { useContext } from 'react';
import { VisitorContext } from './VisitorContext';

export function useVisitor() {
  const context = useContext(VisitorContext);
  
  if (!context) {
    throw new Error('useVisitor must be used within a VisitorProvider');
  }
  
  return context;
}